import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-pan-service',
  templateUrl: './pan-service.component.html',
  styleUrls: ['./pan-service.component.scss']
})
export class PanServiceComponent implements OnInit {
  apiResponse:any;
  GenerateUrlForm: FormGroup;
  CorrectionForm: FormGroup;
  isGenerate:boolean=true;
  isCorrection:boolean=false;
  isloading: boolean;

  modes = [
    { modeName: 'Physical PAN', value: 'P' },
    { modeName: 'E-PAN', value: 'E' },
  ];
  genders: any = ['MALE', 'FEMALE', 'OTHER'];
  isFemale: boolean;
  isMale: boolean;
  isOther: boolean;
  isEmailField: boolean=false;
  refid: any;
  constructor(private service: AuthService, private router: Router, private toastr: ToastrService, private modalService: NgbModal,
    config: NgbModalConfig, private ngxService: NgxUiLoaderService,
    private formBuilder: FormBuilder) {
    this.GenerateUrlForm = this.formBuilder.group({
      mode: ["", Validators.required],
      firstname: ["", Validators.required],
      middlename: [""],
      lastname: ["", Validators.required],
      gender:["", Validators.required],
      title:["", Validators.required],
      email:[""]

    });

    this.CorrectionForm = this.formBuilder.group({
      mode: ["", Validators.required],
      firstname: ["", Validators.required],
      middlename: [""],
      lastname: ["", Validators.required],
      gender:["", Validators.required],
      title:["", Validators.required],
      email:[""]
    });


  }
  get f() { return this.GenerateUrlForm.controls; }
  get f2() { return this.CorrectionForm.controls; }


  generateRandomAlphanumeric(): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let result = '';

    for (let i = 0; i < 12; i++) {
      const randomIndex = Math.floor(Math.random() * charactersLength);
      result += characters.charAt(randomIndex);
    }

    return result;
  }

  generateRandomString(): void {
    const randomString = this.generateRandomAlphanumeric();
    this.refid=randomString;
  }
  ngOnInit(): void {
  }
  complaintType(value) {
     if(value=='generateurl'){
      this.isGenerate=true;
      this.isCorrection=false;
     }else{
      this.isGenerate=false;
      this.isCorrection=true;
     
     }
  }
  onSelectMode(event){
    if(event.value=='E'){
       this.isEmailField=true;
    }else{
      this.isEmailField=false;

    }
  }
  onSelectGender(value){
    if(value=='FEMALE'){
       this.isFemale=true;
       this.isMale=false;
       this.isOther=false;
    }else if(value=='MALE'){
      this.isFemale=false;
      this.isMale=true;
      this.isOther=false;
  
    }else{
      this.isFemale=true;
      this.isMale=true;
      this.isOther=true;
  
    }
  }
  formSubmit(value) {
   
    if(value=='generate'){
      if (this.GenerateUrlForm.invalid) {
        return;
      }
      if(this.GenerateUrlForm.value.mode=='E' && this.GenerateUrlForm.value.email==''){
        this.toastr.error("Email is required")
      }
     this.generateRandomString();
     if(this.GenerateUrlForm.value.mode=='E'){
       var requestData=
       {
          "refid": this.refid,
          "title": this.GenerateUrlForm.value.title,
          "firstname": this.GenerateUrlForm.value.firstname,
          "middlename": this.GenerateUrlForm.value.middlename,
          "lastname": this.GenerateUrlForm.value.lastname,
          "mode": this.GenerateUrlForm.value.mode,
          "gender": this.GenerateUrlForm.value.gender,
          "email":this.GenerateUrlForm.value.email,
          "redirect_url": "https://yourmudra.com"
        } 
        this.ngxService.start();
       this.service.generateUrl(requestData).subscribe((res: any) => {
         this.ngxService.stop();
         if (res.statusCode == 1) {
             this.apiResponse=res.data.htmlForm;
             const newTab = window.open('', '_blank');
             newTab.document.write(this.apiResponse);
             newTab.document.close();

         } else {
           this.toastr.error(res.error.message);
         }
   
       }, err => {
         this.ngxService.stop();
         this.toastr.error(err.error.message);
   
       })
     
     }else{
       var requestData2=
       {
         "refid": this.refid,
         "title": this.GenerateUrlForm.value.title,
         "firstname": this.GenerateUrlForm.value.firstname,
         "middlename": this.GenerateUrlForm.value.middlename,
         "lastname": this.GenerateUrlForm.value.lastname,
         "mode": this.GenerateUrlForm.value.mode,
         "gender": this.GenerateUrlForm.value.gender,
         "redirect_url": "https://yourmudra.com"
       } 
       this.service.generateUrl(requestData2).subscribe((res: any) => {
         this.ngxService.stop();
         if (res.statusCode == 1) {
             this.apiResponse=res.data.htmlForm;
             const newTab = window.open('', '_blank');
             newTab.document.write(this.apiResponse);
             newTab.document.close();
         } else {
           this.toastr.error(res.error.message);
         }
 
       }, err => {
         this.ngxService.stop();
         this.toastr.error(err.error.message);
 
       })
   
     }
   
    }else{

      if(this.CorrectionForm.value.mode=='E' && this.CorrectionForm.value.email==''){
        this.toastr.error("Email is required")
     }
     this.generateRandomString();
     if(this.CorrectionForm.value.mode=='E'){
       var requestData=
       {
          "refid": this.refid,
          "title": this.CorrectionForm.value.title,
          "firstname": this.CorrectionForm.value.firstname,
          "middlename": this.CorrectionForm.value.middlename,
          "lastname": this.CorrectionForm.value.lastname,
          "mode": this.CorrectionForm.value.mode,
          "gender": this.CorrectionForm.value.gender,
          "email":this.CorrectionForm.value.email,
          "redirect_url": "https://yourmudra.com"
        } 

       this.service.correctionUrl(requestData).subscribe((res: any) => {
         this.ngxService.stop();
         if (res.statusCode == 1) {
             this.apiResponse=res.data.htmlForm;
             const newTab = window.open('', '_blank');
             newTab.document.write(this.apiResponse);
             newTab.document.close();  this.CorrectionForm.reset();
           
         } else {
           this.toastr.error(res.error.message);
         }
   
       }, err => {
         this.ngxService.stop();
         this.toastr.error(err.error.message);
   
       })
     
     }else{
       var requestData2=
       {
         "refid": this.refid,
         "title": this.CorrectionForm.value.title,
         "firstname": this.CorrectionForm.value.firstname,
         "middlename": this.CorrectionForm.value.middlename,
         "lastname": this.CorrectionForm.value.lastname,
         "mode": this.CorrectionForm.value.mode,
         "gender": this.CorrectionForm.value.gender,
         "redirect_url": "https://yourmudra.com"
       } 
       this.service.correctionUrl(requestData2).subscribe((res: any) => {
         this.ngxService.stop();
         if (res.statusCode == 1) {
             this.apiResponse=res.data.htmlForm;
             const newTab = window.open('', '_blank');
             newTab.document.write(this.apiResponse);
             newTab.document.close();
             this.CorrectionForm.reset();

           
         } 
       }, err => {
         this.ngxService.stop();
         this.toastr.error(err.error.message);
 
       })
   
     }
   
    }
  }
}
